import { render, staticRenderFns } from "./CurriculumTitle.vue?vue&type=template&id=354f3c9a&scoped=true&"
import script from "./CurriculumTitle.vue?vue&type=script&lang=ts&"
export * from "./CurriculumTitle.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumTitle.vue?vue&type=style&index=0&id=354f3c9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f3c9a",
  null
  
)

export default component.exports